<template>
  <VTable
    :items="taxCredit"
    :fields="fields"
    :checked-rows="checkedItems"
    :loading="loading"
    :on-toggle-row="onToggleRow"
    :on-toggle-all="onToggleAll"
    :on-input-search="onInputSearch"
    :on-edit-item="onEditItem"
    :on-delete-item="onDeleteItem"
    searchPlaceholder="Search for consumer lead...."
    hideAddButton
    hover
    striped
    border
    small
    fixed
    dark
  >
    <template #footer>
      <VPagination
        :items-count="itemsCount"
        class="user-manager-card__footer-pagination"
      />
    </template>
  </VTable>
</template>
<script>
import {
  createTaxCreditMixin,
  taxCreditStore,
} from "@/mixins/taxCreditMixin";
import { debounce } from "@/utils/debounce";
import moment from 'moment'

export default {
  name: "TaxCredit",
  mixins: [createTaxCreditMixin()],
  components: {},
  computed:{
    fields() {
      return [
        {
          key: "name",
          label: "name",
          _style: "min-width: 125px",
          _classes: "name"
        },
        {
          key: "email",
          label: "Email address",
          _classes: "email"
        },
        {
          key: "phone",
          label: "Phone",
          _classes: "phone"
        },
        {
          key: "zipCode",
          label: "zipCode",
          _classes: "phone"
        },
        {
          key: "taxCreditEligible",
          label: " Tax Credit",
          _classes: "phone"
        },
        {
          key: "financing",
          label: "Financing",
          _classes: "phone"
        },
        {
          key: "shippingQuote",
          label: "Shipping Quote",
          _classes: "phone"
        },
        // {
        //   key: "marketplaceLink",
        //   label: "Marketplace Link",
        //   _classes: "phone"
        // },
        {
          key: "evbidsUrl",
          label: "EV Bids Link",
          _classes: "phone",
          _style: "min-width: 125px",

        },
        {
          key: "queryType",
          label: "Type",
          _classes: "type"
        },
        {
          key: "createdAt",
          label: "Date",
          _classes: "phone",
          _style: "min-width: 105px",

        },
      ];
    },
    checkedItems() {
      return this[taxCreditStore.getterTypes.GETTER_CHECKED_ROWS];
    },
    itemsCount() {
      return this[taxCreditStore.getterTypes.GETTER_TAXCREDIT_COUNT];
    },
    taxCredit() {
      let arr = this[taxCreditStore.getterTypes.GETTER_TAXCREDIT];
      if(arr && arr.length > 0){
        for(let i =0; i < arr.length; i++){
          arr[i].createdAt = moment(arr[i].createdAt).format("lll")
          arr[i]['queryType'] = arr[i].type === null ? 'Tax Credit' : arr[i].type
          arr[i]['taxCreditEligible'] = arr[i].taxCreditEligible === 1 ? 'Yes' : 'No'
          arr[i]['financing'] = arr[i].financing === 1 ? 'Yes' : 'No'
          arr[i]['shippingQuote'] = arr[i].shippingQuote === 1 ? 'Yes' : 'No'
        }
      }
      return arr;
    },
  },
  data: () => {
    return {
      loading: false,
      lastSearchTerm: null,
      searchFn: () => {}
    };
  },
  methods:{
    onToggleRow({ item }) {
      this[taxCreditStore.mutationTypes.SET_CHECKED_ROW](item);
    },
    onToggleAll(items) {
      this[taxCreditStore.mutationTypes.SET_CHECKED_ROWS](items);
    },
    onInputSearch(t) {
      this.searchFn(t);
    },
    async loadData() {
      this.loading = true;
      
      await this[taxCreditStore.actionTypes.ACTION_LOAD_TAXCREDIT]({
        skip: this.$route.query.skip || 0,
        take: this.$route.query.take || 10,
        search: this.$route.query.search || ''
      })
      this.loading = false
    },
  },
  watch: {
    $route() {
      console.log('Route changed');

      this.loadData()
    }
  },
  async created() {
    this.loadData()
    this.searchFn = debounce.call(
      this,
      async term => {
        const query = {
          ...this.$route.query,
          search: term
        };

        if (!query.search && query.offset) {
          query.offset = 0;
        }

        this.$router
          .push({
            query
          })
          .catch(() => {});
      },
      200
    );
  }
};
</script>
